import { render } from "./AssetCard.vue?vue&type=template&id=68519420&scoped=true"
import script from "./AssetCard.vue?vue&type=script&lang=js"
export * from "./AssetCard.vue?vue&type=script&lang=js"

import "./AssetCard.vue?vue&type=style&index=0&id=68519420&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68519420"]])

export default __exports__